import React from 'react';

function QuoteButton() {
  return (
    <button className = "QuoteButton">
        Get a quote
    </button>
  )
}

export default QuoteButton